export default __webpack_public_path__ + "static/media/theme-5-top-bg.075b55d6.svg";